import "./Home.module.css";
import Hoofdmenu from "@/reusable_sections/Header";
import CareWithAttentionAtHome from "./sections/CareWithAttentionAtHome";
import WelkomBijCuranovaZorg from "./sections/WelkomBijCuranovaZorg";
import OnzeZorgdiensten from "./sections/OnzeZorgdiensten";
import WaaromKiezenVoorCuraNovaZorg from "./sections/WaaromKiezenVoorCuraNovaZorg";
import PlanEenConsult from "./sections/PlanEenConsult";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Hoofdmenu />
      <CareWithAttentionAtHome />
      <WelkomBijCuranovaZorg />
      <OnzeZorgdiensten />
      <WaaromKiezenVoorCuraNovaZorg />
      <PlanEenConsult />
      <Footer />
    </div>;
}